const generalStore = {
    namespaced: true,
    state: {
        sidebarOpen: false,
        bomVersionItem: {},
        bomVersionInstruction:{},
        attachmentLoading: false,
    },
    getters: {
        isSidebarOpen(state) {
            return state.sidebarOpen;
        },
        getBomVersionItems(state) {
            return state.bomVersionItem;
        },
        getBomVersionInstructions(state) {
            return state.bomVersionInstruction;
        },
        isAttachmentLoading: state => {
            return state.attachmentLoading;
        }
    },
    mutations: {
        setSidebarStatus(state, payload) {
            state.sidebarOpen = payload;
        },
        setBomVersionItems(state, payload) {
            state.bomVersionItem = payload;
        },
        setBomVersionInstructions(state, payload) {
            state.bomVersionInstruction = payload;
        },
        setAttachmentLoading(state, payload) {
            state.attachmentLoading = payload;
        },
    },
    actions: {
        setSidebarStatus(context, payload) {
            context.commit("setSidebarStatus", payload);
        },
        setBomVersionItems(context, payload) {
            context.commit("setBomVersionItems", payload);
        },
        setBomVersionInstructions(context, payload) {
            context.commit("setBomVersionInstructions", payload);
        },
        setAttachmentLoading(context, payload) {
            context.commit("setAttachmentLoading", payload);
        }
    },
};

export default generalStore;